import React from 'react';

const CrossRed = ({ width = 8, height = 8, className, ...rest }) => {
  return (
    <svg
      role="img"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0.62026 6.6215C0.41122 6.83055 0.411228 7.16948 0.620278 7.37852C0.829329 7.58756 1.16826 7.58755 1.3773 7.3785L0.62026 6.6215ZM7.377 1.3785C7.58604 1.16945 7.58604 0.830521 7.37699 0.621481C7.16793 0.41244 6.82901 0.412449 6.61997 0.621499L7.377 1.3785ZM1.3773 7.3785L7.377 1.3785L6.61997 0.621499L0.62026 6.6215L1.3773 7.3785Z"
        fill="#F45C47"
      />
      <path
        d="M1.37711 0.621499C1.16807 0.412448 0.829135 0.41244 0.620085 0.62148C0.411035 0.830521 0.411026 1.16945 0.620066 1.3785L1.37711 0.621499ZM6.61977 7.3785C6.82881 7.58755 7.16774 7.58756 7.37679 7.37852C7.58584 7.16948 7.58585 6.83055 7.37681 6.6215L6.61977 7.3785ZM0.620066 1.3785L6.61977 7.3785L7.37681 6.6215L1.37711 0.621499L0.620066 1.3785Z"
        fill="#F45C47"
      />
    </svg>
  );
};

export default CrossRed;
